// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__QazpK","topDiv":"Footer_topDiv__n0err","bottomDiv":"Footer_bottomDiv__ygpXe","mail":"Footer_mail__bGin2"};